export enum NotificationTypes {
  SHOW_REQUEST = '@notification/SHOW_REQUEST',
  SHOW_SUCCESS = '@notification/SHOW_SUCCESS',
  SHOW_FAILURE = '@notification/SHOW_FAILURE',
  MARK_AS_READ_REQUEST = '@notification/MARK_AS_READ_REQUEST',
  MARK_AS_READ_SUCCESS = '@notification/MARK_AS_READ_SUCCESS',
  MARK_AS_READ_FAILURE = '@notification/MARK_AS_READ_FAILURE',
}

interface NotificationProps {
  actable_type: string;
}

export interface NotificationData {
  notifications: Array<NotificationProps>;
  total_entries: number;
  notification_type: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface NotificationState {
  readonly notification: NotificationData;
  readonly request: RequestState;
}
